<template>
  <div class="d-flex flex-wrap gap-1">
    <a 
      :href="download"
      class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
    >
      Descarga reporte
    </a>
    
    <button 
      @click="$emit('generate-users')" 
      class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
    >
      Generación de credenciales
    </button>
    
    <button 
      @click="$emit('disable-users')" 
      class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
    >
      Deshabilitar Colaboradores
    </button>
    
    <a 
      href="#carga_masiva_estudiante" 
      class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
    >
      Carga masiva
    </a>
    
    <a 
      href="#agregar_estudiante" 
      class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
    >
      Agregar usuario
    </a>
  </div>
</template>

<script>
export default {
  name: 'UserTableActions',
  
  props: {
    download: { type: String, required: true }
  },

  emits: ['generate-users', 'disable-users']
}
</script>